import { useQuery } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useFetchVessels = () => {
  const { token } = useContext(AuthContext);

  const fetchVessels = async () => {
    if (!token) {
      throw new Error("Token is missing");
    }

    const endpoint = `${process.env.REACT_APP_SERVER_URL}/vessel`;

    try {
      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",   
        },
      });

      const responseData = await response.json();

      if (!response.ok) {
        throw new Error(responseData.message || `Failed to fetch vessels (${response.status})`);
      }

      return responseData;
    } catch (error) {
      if (error.name === 'TypeError' && error.message.includes('fetch')) {
        throw new Error("Network error: Unable to connect to server");
      }
      throw error;
    }
  };

  const {
    data: vesselsData,
    error: vesselsError,
    isLoading: vesselsLoading,
    refetch: refetchVessels,
  } = useQuery(
    ["vessels"],
    fetchVessels,
    {
      enabled: !!token,
      refetchOnWindowFocus: false,
      retry: 1,
    }
  );

  return {
    vessels: vesselsData?.data || [],
    vesselsError,
    vesselsLoading,
    refetchVessels,
  };
};

export default useFetchVessels; 